import React, {useEffect, useState} from 'react'
import FieldDropdown from '../components/FieldDropdown';
import BlueButton from '../components/BlueButton';
import { useStateContext } from '../context/StateContext';
import { useAuthContext } from '../whitaijiFrontendLibrary/auth/hooks/useAuthContext';
import { AuthContext } from '../context/AuthContext';
import { isGodMode, NoAccess, isMindPro } from '../utils/permissions';
import T from '../components/Translation';
import { PersonalData } from '../components/Survey';
import ProfilePicture from '../components/imageCrop/ProfilePicture';
import { Country } from 'country-state-city';
import { useQuery } from '@tanstack/react-query';
import { _FETCH } from '../utils/patches';
import { successAlert } from '../utils/utils';



const Profile = () => {

      const {user, dispatch} = useAuthContext(AuthContext)
      const { data: userProfileData, error, isLoading: userProfileDataLoading } = useQuery({
        queryKey: ['userProfileData'],
        enabled: !!user, // Only fetch if user is logged in
        queryFn: async () => {
            const userData = await _FETCH({
              route: `${apiUrl}/user/get-user-profile/${user._id}`,
              user,
            });

            return userData;
          }
    });
      const {hideTestButtons, apiUrl} = useStateContext()
      const [userInfoData, setUserInfoData] = useState({...user})

      useEffect(() => {
        if (userProfileData) {
          process.env.NODE_ENV === "development" && console.log("userProfileData", userProfileData)
          setUserInfoData({...userProfileData, ...userInfoData})
        }
      }, [userProfileData]);
      const testFunction = () => {
        process.env.NODE_ENV === "development" && console.log("testFunction",
          {
            userInfoData,
            user
          }
        )
        }
      const uploadPictureToS3 = async() => {
        try {
          process.env.NODE_ENV === "development" && console.log("uploadPictureToS3 called with userInfoData:", {
            hasPhotoFile: !!userInfoData?.photoFile,
            photoFileType: typeof userInfoData?.photoFile,
            hasFile: !!userInfoData?.photoFile?.file,
            fileType: typeof userInfoData?.photoFile?.file
          });
          
          const image = userInfoData?.photoFile?.file;
          if(!image){
            throw new Error('No Photo file');
          }
          
          // Create form data for S3 upload
          const formData = new FormData();
          formData.append('file', image);
          
          // The user ID is extracted from the JWT token on the server side
          // through the requireAuth middleware, so we don't need to pass it explicitly
          process.env.NODE_ENV === "development" && console.log("Uploading profile picture to S3");

          // Upload to S3
          const s3Response = await fetch(`${apiUrl}/s3/upload-profile-picture`, {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${user.token}`
            },
            body: formData
          });

          // Parse the response data
          const responseData = await s3Response.json();
          
          if (!s3Response.ok) {
            throw new Error(responseData.error || 'Failed to upload image to S3');
          }
          
          // Update the user info with the new profile picture URL
          setUserInfoData({
            ...userInfoData,
            profilePictureUrl: responseData.profilePictureUrl
          });
          
          process.env.NODE_ENV === "development" && console.log('Successfully uploaded profile image:', responseData.profilePictureUrl);
          return ({success: true, profilePictureUrl: responseData.profilePictureUrl});
        } catch (error) {
          process.env.NODE_ENV === "development" && console.error('Error uploading profile picture:', error);
          return ({success: false});
        }
      }

      const saveUserInfo = async() => {
        try {
          const image = userInfoData?.photoFile?.file
          let profilePictureUrl 
          // Upload profile picture to S3
          if(image){
            const uploadPictureResponse = await uploadPictureToS3()
            if(!uploadPictureResponse.success){
              throw new Error('Failed to upload profile picture')
            }
            
            // The profile picture URL is already updated in the state by uploadPictureToS3
            process.env.NODE_ENV === "development" && console.log('Successfully saved profile picture:', uploadPictureResponse.profilePictureUrl);
            profilePictureUrl = uploadPictureResponse.profilePictureUrl
          }

         const userInfoToPass = {
          firstName: userInfoData.firstName,
          lastName: userInfoData.lastName,
          country: userInfoData.country,
          city: userInfoData.city,
          phoneNumber: userInfoData.phoneNumber,
          professionalTitle: userInfoData.professionalTitle,
          profilePictureUrl: profilePictureUrl,
          acceptMarketing: userInfoData.acceptMarketing
         }
          // You can uncomment this section if you want to save other user info
          
          const response = await fetch(`${apiUrl}/user/update-profile`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${user.token}`
            },
            body: JSON.stringify(userInfoToPass)
          });
          if (!response.ok) {
            const error = await response.json();
            throw new Error(error.error || 'Failed to save user info');
          }
          
          if(response.ok){
            process.env.NODE_ENV === "development" && console.log('Successfully saved user info');
            if(profilePictureUrl) {
              
              const newProfilePictureUrl = `${profilePictureUrl}?v=${Date.now()}`
              localStorage.setItem('user', JSON.stringify({...user, profilePictureUrl: newProfilePictureUrl}));

              // update the auth context
              dispatch({type: 'LOGIN', payload: {...user, profilePictureUrl: newProfilePictureUrl}});
            }
            successAlert()
          }
          
        } catch (error) {
          process.env.NODE_ENV === "development" && console.error('Error saving user info:', error);
        }
      }

/*     if (!isGodMode(user) && !isMindPro(user)) {
        return <NoAccess />
    } */

  return (
    <div style={{padding: "30px"}}>
      <BlueButton fn={testFunction} hide={hideTestButtons} />  
      <BlueButton fn={saveUserInfo} text='Save' color='green' />  
      {/* <T obj={{en:"My Profile", it:"Il Mio Profilo"}}/>  */}
      <ProfilePicture doc={userInfoData} setDoc={setUserInfoData} profile={true}/>
      <PersonalData showValidation={false} hideConsent={true} data={{doc: userInfoData, setDoc: setUserInfoData }} />
      <BlueButton fn={saveUserInfo} text='Save' color='green' /> 
    </div>
  )
}

export default Profile
